import { LOCALES } from "../locales";

export default {
  [LOCALES.CHINESESIMPLIFIED]: {
    // general product translation
    January: "1",
    February: "2",
    March: "3",
    April: "4",
    May: "5",
    June: "6",
    July: "7",
    August: "8",
    September: "9",
    October: "10",
    November: "11",
    December: "12",
    class_policy: "课程政策",
    Faq: "FAQs",
    help: "帮助",
    frequently_asked_ques: "常问问题",
    customer_support: "客户支持",
    user_name: "用户名",
    password: "密码",
    email_address: "电子邮件地址",
    // Header Translations
    notification: "通知",
    page_loading_aria: "页面正在加载",
    state_loading_aria: "州正在加载",
    city_loading_aria: "城市正在加载",
    badge_placeholder: "Badge placeholder",
    badge_overall: "徽章总览",
    badge_demo_skills: "Badge placeholder for demo user, skills",
    badge_demo_be: "Badge placeholder for demo user, business english",
    certificate_placeholder: "证书图片",
    certificate_download: "下载证书按钮",
    prev: "上一页",
    log_out: "登出",
    // feature names
    feature_progress: "进度",
    feature_stressAndIntonation_title: "重音和语调",
    feature_soundOfEnglish_title: "英语声音",
    feature_vocabularyCenter_title: "词汇中心",
    feature_grammarCenter_title: "语法中心",
    feature_culture_centre_title: "文化中心",
    feature_globalCommunityTutorials_title: "Global Community Tutorials",
    feature_industryfeed_title: "行业资讯",
    feature_newsfeed_title: "新闻提要",
    feature_emailTemplates_title: "电子邮件模板",
    feature_talkWithTeacher_title: "Talk with teacher",
    feature_accentsAndDialects_title: "口音与方言",
    feature_writingCenter_title: "写作中心",
    feature_toeic_title: "TOEIC",
    feature_toefl_title: "TOEFL",
    // Footer translations
    about: "关于",
    legal: "法律",
    privacy_policy: "隐私政策",
    Terms_conditions: "条款及细则",
    //button translations
    button_continue: "继续",
    button_KnowMore: "了解更多",
    button_BuyNow: "立即购买",
    button_Subscribe: "订阅",
    button_GetStarted: "使用入门",
    button_view: "View",
    button_GoText: "Go",
    button_Resume: "Continue learning",
    button_ViewDetails: "查看详情",
    button_ContinueStudying: "继续",
    button_next: "下一个",
    button_confirm: "确认",
    // cookie policy
    common_cookiesPolicyText1: "Learnship使用cookies，以保证你能得到最好的服务。如果您停留在本网站上，",
    common_cookiesPolicyText2: "您就同意使用cookies",
    // EO cookie policy
    //login-page-translations//
    login_welcome: "欢迎",
    login_heloo: "再次欢迎",
    login_welcome_text: "让我们开始吧",
    login_log_in: "登录",
    login_errorIncorrectCreds: "用户名或密码不正确",
    login_errorContactAmin: "您的帐户未处于活动状态。请联系您的管理员。",
    login_errorSSOuser: "您的帐户未处于活动状态。请联系您的管理员。",
    login_forgotPassword: "忘记了您的密码？",
    login_resetPasswordTitle: "重设密码",
    login_resetSuccess: "我们已向您发送了一封电子邮件，其中包含可以让您重置密码的链接。",
    login_resetFailure: "电子邮箱地址不正确",
    // common translations
    message_errorDefault: "出现错误",
    message_successUpdated: "更新成功",
    message_unknownError: "Unknown error",
    message_unAuthorized: "您尚未经授权",
    message_passwordUpdated: "密码更新成功",
    message_profileUpdated: "个人资料更新成功",
    message_welcomeSubmitted: "信息提交成功",
    message_samepasswordError: "请输入新密码。确保不是已经使用过的密码。",
    SAR: "选择一个地区",
    SAL: "选择一个位置",
    SAT: "选择一个话题",
    SAA: "选择一种语言",
    link_readmore: "阅读更多",
    //--//
    profile_title: "个人资料",
    profile_nameLabel: "我的名字是： ",
    profile_countryLabel: "国家/地区",
    profile_stateLabel: "州/省/地区",
    profile_cityLabel: "城市",
    profile_emailLabel: "电子邮件",
    profile_prefContactLabel: "优选联系方式",
    profile_prefSkypeLabel: "个人Skype账号",
    profile_prefMobileLabel: "移动电话号码",
    profile_prefLandlineLabel: "座机号码",
    profile_agreeTerms1: " ",
    profile_agreeTerms2: "我接受并同意 条款及条件",
    profile_continueAria: "继续按钮",
    profile_TermsAria: "接受条款",
    profile_stateTooltip: "您的时区将帮助我们为您安排在线课程。",
    profile_cityTooltip: "如果您不住在此处显示的城市之一，请选择离您最近的城市。",
    profile_emailTooltip: "验证您的电子邮件",
    profile_prefTooltip:
      "即使您在注册过程中指定了其他联系方式，您的全部课程将会通过虚拟课堂进行。 我们询问您的首选联系方式仅为内部使用，以便我们可以不断改善您的学习体验。",
    profile_fnamePlaceholder: "名字",
    profile_lnamePlaceholder: "姓氏",
    profile_countryPlaceholder: "选择国家/地区",
    profile_prefContactSelect: "选择您的偏好",
    profile_statePlaceholder: "选择州",
    profile_cityPlaceholder: "选择城市",
    profile_emailInvalidMessage: "电子邮件地址无效",
    profile_prefContactPlaceholder: "选择您的偏好",
    profile_prefSkypePlaceholder: "个人Skype",
    profile_emailVerifiedChip: "已验证",
    profile_emailVerifyChip: "验证",
    profile_emailpopup_head: "输入验证码",
    profile_emailpopup_codePlaceholder: "Code",
    profile_emailpopup_resendText: "重新发送验证码",
    profile_emailpopup_resendMessage: "没有收到验证码？",
    profile_invalidNumber: "无效号码",
    profile_prefSkypeAria: "个人Skype账号为优选联系方式",
    profile_prefMobileAria: "移动电话为优选联系方式",
    profile_prefLandlineAria: "座机电话为优选联系方式",
    profile_emailpopup_incorrectCode: "无效代码",
    profile_editLabel: "编辑个人资料",
    profile_editAria: "编辑按钮",
    profile_mainPasswordPlaceholder: "在此处输入密码",
    profile_updateLabel: "更新",
    profile_welcomeJumbotron: "请告诉我们您的基本情况。",
    profile_cancelLabel: "取消",
    noAccessl1: "糟糕！您无权查看此页面。",
    noAccessl2: "这个链接可以回到",
    noAccessl2_1: "主页面",
    noAccessl3: "请联系您的Learnship管理员以获取帮助。",
    profile_license_information: "License information",
    profile_license_message: "您的许可证到期时间为",
    profile_changepass_changepassHead: "更改密码",
    profile_changepass_currentpassword: "当前密码",
    profile_changepass_currentpasswordPlaceholder: "输入当前密码",
    profile_changepass_newpassword: "新密码",
    profile_changepass_newpasswordPlaceholder: "输入新密码",
    profile_changepass_confirmnewpassword: "确认新密码",
    profile_passMustInclude: "您的密码必须满足以下要求。",
    profile_passdontmatch: "密码不匹配",
    profile_incorrectPassword: "密码错误",
    profile_passwordSubmit_title: "输入密码",
    profile_changepass_conditionLength: "8至32个字符",
    profile_changepass_conditionUppercase: "至少一个大写字母",
    profile_changepass_conditionLowercase: "至少一个小写字母",
    profile_changepass_conditionSpecialCharacters: "至少一个数字或$!#&@?%*_中的一个符号",
    profile_translationLanguage: "翻译",
    profile_translationLanguagePlaceholder: "选择语言",
    profile_managerEmailPlaceholder: "经理电子邮箱",
    profile_managerEmailpopupPlaceholder: "经理的电子邮件地址",
    // Learner Home Page translations
    learnerhome_survey_header: "我们期待您的反馈！",
    learnerhome_survey_line1: "贵公司希望了解您使用我们服务的体验。",
    learnerhome_survey_line2: "请通过以下方式完成我们的调查。",
    learnerhome_survey_line3: "您的反馈非常重要，非常感谢。",
    learnerhome_survey_button1: "接收调查",
    learnerhome_survey_button2: "跳过调查",
    active_course: "Active course",
    admin_header: "Administration",
    admin_dashboard_header: "Dashboard",
    get_startedText: "点击下面的课程开始",
    product_solo_desc: "我们的在线学习产品Learnship Solo为学习者提供按照自己的节奏练习和提高其商务语言技能所需的一切。",
    product_conversationPractice_desc:
      "学习者可以与培训师预约进行一对一的课程，可以提出或讨论特定问题，或进行角色扮演。 对于希望提高技能的经验丰富的学习者非常有用。",
    product_sprint_businessSkills_desc:
      "新一代混合型学习课程可以帮助学习者在极短时间内提升特定的商务技能，如演讲、谈判、商务写作和参与会议。",
    product_sprint_levelsProgress_desc: "我们的新一代混合型语言学习可以帮助您的员工在标准化框架下快速提升英语技能。",
    product_sprint_business_german_desc: "我们的新一代混合型语言学习可以帮助您的员工在标准化框架下快速提升德语技能。",
    product_sprint_business_french_desc: "我们的新一代混合型语言学习可以帮助您的员工在标准化框架下快速提升法语技能。",
    product_sprint_business_spanish_desc:
      "我们的新一代混合型语言学习可以帮助您的员工在标准化框架下快速提升西班牙语技能。",
    product_sprint_business_skills_groups_desc:
      "This next-generation blended learning program helps learners develop specific business skills— in groups—in record time.",
    product_evolve_relocationLanguage_desc:
      "我们的新一代混合型语言学习可以帮助您的员工在标准化框架下快速提升英语技能。",
    product_evolve_culturePowerSkills_desc: "为您的员工提供在国际化工作环境和全球化虚拟团队中发展所需的跨文化技能。",
    product_evolve_cultureFocus_desc:
      "针对需要更好了解特定区域及其工作文化的学习者进行的特定国家导向型和文化知识培训。",
    product_evolve_cultureChange_desc:
      "这是我们针对外派员工的首要跨文化商务培训课程。可以使学习者对新文化中的生活和工作有深入的了解。",
    product_elevate_businessSkills_desc:
      "针对想要提高特定商业技能（例如演示，谈判或团队领导能力）的语言学习者的简短、标准化的培训模块。我们同时还提供针对特定行业术语的专业课程。",
    product_elevate_levelsProgress_desc:
      "这项培训师引导式商务语言课程可以帮助学习者在标准化框架下提高其书面和口头表达能力。",
    product_coach_languageCoach_desc:
      "在会议室里、通过电子邮件、在谈判中甚至在饮水机周围都可以进行自信、清晰的沟通。我们的一对一、超具体的高级语言辅导可以帮助您掌控最重要的商务情景。提升您的口语、书面、会议和个人沟通技巧。",
    product_coach_cultureCoach_desc: "针对寻求解决特定跨文化沟通问题的高级管理人员的高度专注的一对一辅导课程。",
    product_solo_business_english:
      " 一个包括引人入胜的在线练习的多层次学习课程，让您可以按照自己的节奏提升商务英语的知识与应用。",
    product_solo_business_german:
      "一个包括引人入胜的在线练习的多层次学习课程，让您可以按照自己的节奏提升商务德语的知识与应用。",
    product_solo_business_french:
      "一个包括引人入胜的在线练习的多层次学习课程，让您可以按照自己的节奏提升商务法语的知识与应用。",
    product_solo_business_spanish:
      "一个包括引人入胜的在线练习的多层次学习课程，让您可以按照自己的节奏提升商务西班牙语的知识与应用。",
    product_lorem_desc: "Lorem Ipsum lorstatment , consect eturadips cingelioremp.",
    product_dashboard_desc:
      "这是进入Dashboard的通道，一个直观的界面，允许管理员跟踪使用情况，分析学习者的进展，优化课程项目并评估投资回报率。",
    product_elevate_desc:
      "Elevate Business English 是我们线上面对面的语言培训项目，适合那些希望与个人培训师一起提高整体语言能力的学习者。",
    product_reach_desc:
      "Enhance your learning journey with personalized micro-modules and side missions focusing on real-world business skills.",
    product_lorem_solo_desc: "丰富的多媒体课程帮助您的员工在标准化框架下迅速提升英语技能",
    //feature translations
    feature_cultureCentre_desc: "熟悉对您的业务和职业生活至关重要的地区的文化。",
    feature_emailTemplates_desc:
      "电子邮件模板涵盖了各种各样的业务主题。选择所需的模板，然后将其直接导出到您的电子邮件客户端，以便您可以直接进行编辑。",
    feature_newsFeed_desc: "欢迎来到我们革命性的世界新闻体验！通过我们Learnship系统实时生成的内容和问题来学习英语。",
    feature_talkWithTeacher_desc:
      "This is for learners who want to apply their new skills in conversation. Users can join a virtual group classroom to practice their chosen language and take part in Q&As with speaking speacialists.",
    feature_industryFeed_desc: "行业咨询结合了行业特定文章库和AI驱动的语言练习。选择一篇您想要练习的语法点的文章。",
    feature_accentsAndDialects_desc: "通过区域化样本库来探索全球英语使用的丰富性。",
    feature_stressAndIntonation_desc:
      "通过学习在说话时如何使用正确的重音、节奏和语调，使您的英语更自然，更容易被理解。",
    feature_soundOfEnglish_desc: "通过学习正确的英语发音，从而提高沟通技能。",
    feature_vocabularyCenter_desc: "没有语法几乎无法传达信息。没有词汇，根本无法传递信息。——大卫·威尔金斯",
    feature_grammarCenter_desc:
      "语法中心将帮助您在口语和写作中使用正确的语法。包括语法主题，例如基本句子成分、动词和动词形式以及句子及从句。",
    feature_globalCommunityTutorials_desc: "通过社区型开发的课程不断增长，可以提高您的英语语言技能。",
    feature_toeic_desc:
      "TOEIC®考试是跨国公司最广泛用于衡量员工英语水平的工具。TOEIC®使用真实的书面材料和对话来评估您的商务英语技能。",
    feature_toefl_desc: "TOEFL®，英语作为外语的测试，在全球范围内被高校、政府机构和奖学金计划使用来评估英语水平。",
    feature_businessSituations_desc:
      "商务情形索引使您可以轻松地找到特定的活动，以便您可以专注于在各种商务情形下进行交流所需的语言。",
    //carousel block translations
    title_feature: "功能",
    we_recommend: "我们还向您推荐",
    // session report translations
    SessionReport_sessionReport: "课程报告",
    SessionReport_sessionDetails: "具体",
    SessionReport_teacherName: "培训师姓名",
    SessionReport_sessionReview: "课程回顾",
    SessionReport_sessionFeedback: "课程反馈",
    SessionReport_sessionMaterials_Assignments: "课程材料及任务",
    SessionReport_instructions: "说明",
    SessionReport_open: "打开",
    SessionReport_invalidSession_Message: "对不起，尚无该课程的报告。",
    SessionReport_rateSession: "对课程评分",
    SessionReport_handouts: "Handouts",
    SessionReport_coachName: "对课程感觉如何",
    SessionRating_sessionDate: "课程日期",
    SessionRating_sessionTime: "课程时间",
    SessionRating_sessionDuration: "课程期限",
    SessionRating_status: "状态",
    SessionRating_rateYourExperience: "对您的体验评分",
    SessionRating_whatWentWrong: "出了什么问题？",
    SessionRating_content: "内容",
    SessionRating_technology: "技术",
    SessionRating_comment: "请评论",
    SessionRating_submit: "提交",
    SessionRating_remindMeLater: "稍后提醒我",
    SessionRating_close: "关闭",
    SessionRating_completed: "已完成",
    sessionRating_sessionDetails_mins: "分钟",
    // my schedule page translations
    myschedule_availability_abty_given: "我们正在努力为您寻找匹配的培训师。",
    myschedule_schedule: "课程日程",
    myschedule_availability_needAvl: "我们需要您的可用时间来为您安排课程。",
    myschedule_availability_abty_not_given: "提供/修改您的可用时间",
    myschedule_statusCard_completed: "完成的课程",
    myschedule_statusCard_remaining: "剩余的课程",
    myschedule_statusCard_scheduled: "待安排课程",
    myschedule_statusCard_lost: "缺席课程（晚取消或缺席）",
    myschedule_recentUpcoming_courseName: "课程名称",
    myschedule_next_session: "下一节课",
    myschedule_session_topic: "课程主题",
    myschedule_sessionDetails_communication: "沟通",
    myschedule_sessionDetails_allSessions: "全部课程",
    myschedule_sessionDetails_upcomingSessions: "即将进行的课程",
    myschedule_sessionDetails_pastSessions: "之前的课程",
    myschedule_sessionDetails_teacher_name: "培训师",
    myschedule_sessionDetails_sessions: "数字",
    myschedule_sessionDetails_date: "日期",
    myschedule_sessionDetails_time: "时间",
    myschedule_sessionDetails_durationText: "时长",
    myschedule_sessionDetails_min: "分钟",
    myschedule_reschedule_Title: "如何重新安排课程",
    myschedule_reschedule_InstrBegin: "您可以按照如下方法重新安排与培训师的课程：",
    myschedule_reschedule_instr1a: "在顶部查看课程详细信息",
    myschedule_reschedule_instr1b: "您课程的日期及时间显示在顶部。",
    myschedule_reschedule_instr2: "培训师的可用时间显示为绿色",
    myschedule_reschedule_instr3: "您将看到培训师的可用时间。可用时间段以绿色标记。",
    myschedule_reschedule_instr4: "选择一个时间段来重新安排课程时间",
    myschedule_reschedule_instr5: "要重新安排课程时间，请点击您选择的可用时间段的绿色区域。",
    myschedule_reschedule_next_instr1: "没有合适的时间段",
    myschedule_reschedule_next_instr2:
      "尽量避免直接取消课程，如果您确实找不到与培训师适合的时间，请使用“没有合适的时间段”按钮取消您的课程。在这种情况下，您的培训师将为您安排该课程，或者管理员将会为您提供帮助。",
    myschedule_reschedule_next_instr3: "更换培训师",
    myschedule_reschedule_next_instr4a: "如果您打算为一节或更多剩余课程更换培训师，请使用我们的",
    myschedule_reschedule_next_instr4b: "联系表格",
    myschedule_reschedule_next_instr4c: "选择 {productname} 及 'Change Trainer'。请提供您更换培训师的原因。",
    myschedule_rechedule_next_info: "更多有关课程改期及取消的信息，请访问我们的",
    myschedule_rechedule_next_faq: "常见问题网站。",
    myschedule_rechedule_next_noShow: "不再显示此信息页面",
    myschedule_rechedule_next_done: "完成",
    myschedule_rechedule_skipButton: "跳过",
    myschedule_upcoming_joinNow: "现在参加",
    myschedule_cancel_question: "您确定要取消这节课程吗?",
    myschedule_cancel_button: "取消课程",
    myschedule_cancel_no: "不",
    myschedule_invalid_session: "对不起，这是一节无效的课程",
    myschedule_sessionDuraion_minutes: "分钟",
    myschedule_homepage_view: "查看",
    myschedule_finished_status: "完成",
    myschedule_reschedule_button: "重新安排",
    myschedule_addToCalendar_instr1: "点击",
    myschedule_addToCalendar_instr2: "下载按钮以获取您的Learnship学习计划。您可以将它添加到个人日历中。",
    myschedule_addToCalendar_instr3: "如果您之前在日历中添加过Learnship学习计划，请确保先删除现有的计划表。",
    myschedule_addToCalendar_instr4: "了解更多关于如何将Learnship学习计划添加到个人日历的信息",
    myschedule_addToCalendar_instr5: "这里",
    myschedule_no_teacher_title: "未指定教师",
    myschedule_no_teacher_body: "目前尚不能添加课程（未指定教师）。请联系 coach@globalenglish.com 来继续您的课程项目。",
    myschedule_no_sessions: "没有发现课程",
    myschedule_no_upcoming_sessions: "没有发现即将开始的课程",
    myschedule_no_past_sessions: "没有发现已结束的课程",
    myschedule_status_lost: "丢失的",
    myschedule_status_finished: "完成的",
    myschedule_status_completed: "已完成",
    myschedule_status_cancelled: "已取消",
    myschedule_status_inprogress: "进行中",
    myschedule_status_pending: "待定",
    myschedule_status_active: "已激活",
    myschedule_status_inplanning: "计划中",

    // my schedule page translations end
    // Progress page
    progress_title: "我的进度",
    progress_activity_report: "活动报告",
    progress_test_results: "测试结果",
    progress_productname_sprint_skills: "快速提升商务技能",
    progress_productname_reach_skills: "达到技能",
    progress_skill_note: "您必须完成至少70% 的课程才可以获得结业证书。",
    progress_overall_card_title_prework: "课前预习完成",
    progress_overall_card_title_homework: "作业完成",
    progress_overall_card_title_session: "会话完成",
    progress_overall_card_title_certificate: "证书",
    progress_overall_card_title_skillsCompleted: "已完成的技能",
    progress_overall_card_title_badgesEarned: "已获取的徽章",
    progress_overall_card_title_missionsPassed: "已通过的任务",
    progress_overall_card_title_timeInReach: "在 Reach 中所用时间 (HH:MM)",
    progress_noSubskill: "没有可显示的子技能",
    progress_tab_nodata: "没有数据在这里显示",
    progress_percentCompleted: "已完成百分比",
    progress_subskill_preworkTitle: "课前预习",
    progress_subskill_homeworkTitle: "作业",
    progress_subskill_sessionTitle: "课程",
    progress_subskill_sessionStatusCompleted: "完成",
    progress_subskill_sessionStatusNotCompleted: "尚未完成",
    progress_subskill_sessionStatusNoSessions: "没有课程",
    progress_subskill_sessionNoDate: "N/A",
    progress_activity_tooltip_totaltime: "总时间",
    progress_activity_tooltip_activitiesCompleted: "完成活动",
    progress_activity_tooltip_reachMissionsCompleted: "Reach中完成的任务",
    progress_activity_tooltip_timeinhhmm: "时间 （HH:MM）",
    progress_activity_tabDaily: "每天",
    progress_activity_tabWeekly: "每周",
    progress_activity_tabMonthly: "每月",
    progress_activity_tabQuarterly: "每季度",
    progress_activity_tabQuarter: "季度",
    progress_activity_tabYearly: "每年",
    progress_acitivity_Minutes: "分钟",
    progress_acitivity_legend_selfpaced: "自主学习时间",
    progress_acitivity_legend_trainerLed: "培训师引导学习时间",
    progress_acitivity_legend_recommended: "推荐的",
    progress_testresults_table_testname: "测试名称",
    progress_testresults_table_scores: "评分",
    progress_testresults_table_date: "日期",
    progress_testresults_info: "您的考试结果将在24小时内显示。",
    progress_inprogress: "进行中",
    progress_totalscore: "总分数",
    progress_placedText: "级别",
    progress_button_viewscore: "View detailed report",
    progress_certificate_download_success: "Downloaded successfully",
    progress_partText: "部分",
    progress_emptyPartText: "Other",
    progress_overall_card_title_badge: "Badge",
    progress_badge_dialog_box_title: "为了获取结业证书，您需要完成70%的数字化练习。",
    progress_badge_dialog_box_golden: "成功率达到80%，可以获得黄金徽章",
    progress_badge_dialog_box_silver: "成功率在70%至79%之间，可以获得白银徽章",
    progress_badge_dialog_box_bronze: "成功率在50%至69%之间，可以获得青铜徽章",
    progerss_badge_dailog_box_digitalActivities: "成功率是通过您在在线数字活动中的表现和参与度计算得到的。",
    progress_badge_dailog_box_liveSessions: "成功率是通过您在在线数字活动和在线课程中的表现和参与度计算得到的。",
    progress_elevate_dialog_box_liveSessions:
      "The success score is calculated based on your performance and engagement with live sessions",

    //EO Progress page
    //Email Templates
    wcTitle: "写作中心",
    guidelines: "写作指导",
    sampleDocs: "样本文件",
    languageSelect: "Select a language",
    wcGroup1: "道歉",
    wcGroup2: "投诉",
    wcGroup3: "赞美",
    wcGroup4: "祝贺",
    wcGroup5: "文件",
    wcGroup6: "邀请",
    wcGroup7: "求职申请",
    wcGroup8: "营销",
    wcGroup9: "会议",
    wcGroup10: "通告",
    wcGroup11: "订单",
    wcGroup12: "定价信息",
    wcGroup13: "请求",
    wcGroup14: "致谢",
    wcTitle11: "道歉－项目延误",
    wcTitle12: "道歉－账户错误",
    wcTitle13: "道歉－送货延误",
    wcTitle14: "道歉－寄送损坏物品",
    wcTitle15: "道歉－错过会议",
    wcTitle21: "一般投诉",
    wcTitle22: "投诉－产品有问题",
    wcTitle23: "投诉－账户被超额扣款",
    wcTitle31: "赞美－同事在项目中的表现",
    wcTitle32: "赞美－客户服务",
    wcTitle33: "赞美－产品",
    wcTitle41: "祝贺－升职（正式）",
    wcTitle42: "祝贺－升职（非正式）",
    wcTitle43: "祝贺－私事",
    wcTitle51: "索取的文件",
    wcTitle52: "订单或采购单",
    wcTitle53: "发票",
    wcTitle61: "邀请－社交活动",
    wcTitle62: "邀请－商务活动",
    wcTitle63: "接受邀请",
    wcTitle64: "谢绝邀请",
    wcTitle65: "取消商务活动",
    wcTitle71: "申请表回执",
    wcTitle81: "公布新产品",
    wcTitle82: "宣布新地区代表",
    wcTitle83: "新产品演示",
    wcTitle84: "更改计费单地址",
    wcTitle85: "跟进第一次销售会议",
    wcTitle86: "欢迎新客户",
    wcTitle87: "致股东或客户节日祝福",
    wcTitle91: "建议开会时间",
    wcTitle92: "确定会议",
    wcTitle93: "延迟会议",
    wcTitle94: "取消会议",
    wcTitle95: "会议摘要",
    wcTitle101: "冻结账户",
    wcTitle102: "要求关闭账户",
    wcTitle111: "确定订单",
    wcTitle112: "提供运送确认",
    wcTitle113: "取消订单",
    wcTitle114: "更改订单",
    wcTitle115: "确认送达",
    wcTitle121: "提供定价信息",
    wcTitle122: "接受报价",
    wcTitle123: "回绝报价",
    wcTitle131: "要求澄清信息",
    wcTitle132: "要求产品信息",
    wcTitle133: "要求服务信息",
    wcTitle141: "一般致谢",
    guideGroup1: "常见写作问题",
    guideGroup2: "一般商业通讯",
    guideGroup3: "商业文件",
    guideTitle11: "文章内容含糊不清的原因",
    guideTitle12: "基本写作错误",
    guideTitle13: "动词问题",
    guideTitle21: "商业通讯中直截了当",
    guideTitle22: "营销用语",
    guideTitle23: "日常商业习惯用语",
    guideTitle31: "有效的电子邮件",
    guideTitle32: "演说：一般要点",
    guideTitle33: "演说：有效的开场白",
    backIndex: "回到索引",
    copyText: "复制文字",
    exportEmail: "导出文字到电子邮件",
    beActivity: "商务英语级别 <course>，作业 <assign>，活动 <act>",
    Blob: "电子邮件模板涵盖了丰富的商务主题。 选择您所需的模板并直接导出到您要在此进行编辑的电子邮件客户端。",
    OpenInEmail: "在电子邮件中打开",
    Quote1: "目前全球有 33 亿个电子邮件账户。",
    Quote1By: "Mashable",
    Quote2: "与其他渠道相比，电子邮件生成将近两倍的回复。",
    Quote2By: "直接营销主管",
    Quote3: "每秒发送 350 万封电子邮件。",
    Quote3By: "营销主管",
    SelectACategory: "选择类别",
    Title: "电子邮件模板",
    WatchTutorial: "观看视频教程",
    String: "Quote1",
    //Culture Notes Dropdowns
    NoAm: "北美洲",
    Cenam: "中美洲",
    SoAm: "南美洲",
    EUR: "欧洲",
    ASIA: "亚洲",
    CenASIA: "中亚",
    SoEASIA: "东南亚",
    MidEAST: "中东",
    AFR: "非洲",
    AUST: "澳大利亚",
    Cana: "加拿大",
    Mexi: "墨西哥",
    Uniteds: "美国",
    CostaR: "哥斯达黎加",
    DomRep: "多米尼加共和国",
    Guate: "瓜地马拉",
    Jama: "牙买加",
    Panam: "巴拿马",
    TriniTob: "特立尼达和多巴哥",
    Arge: "阿根廷",
    Braz: "巴西",
    Chil: "智利",
    Vene: "委内瑞拉",
    Colomb: "哥伦比亚",
    Peru: "秘鲁",
    Urug: "乌拉圭",
    Austria: "奥地利",
    Belg: "比利时",
    Bulg: "保加利亚",
    Croatia: "克罗地亚",
    Czec: "捷克共和国",
    Denm: "丹麦",
    Finl: "芬兰",
    Fran: "法国",
    Germ: "德国",
    Greec: "希腊",
    Hung: "匈牙利",
    Icel: "冰岛",
    Irel: "爱尔兰",
    Ital: "意大利",
    Lith: "立陶宛",
    Luxem: "卢森堡",
    Neth: "荷兰",
    Norw: "挪威",
    Pola: "波兰",
    Port: "葡萄牙",
    Roma: "罗马尼亚",
    Russ: "俄罗斯联邦",
    Serb: "塞尔维亚",
    Slovakia: "斯洛伐克",
    Slovania: "斯洛文尼亚",
    Spai: "西班牙",
    Swed: "瑞典",
    Swit: "瑞士",
    Turk: "土耳其",
    Ukra: "乌克兰",
    Unitedk: "英国",
    Chin: "中国",
    Hong: "香港",
    Indi: "印度",
    Japa: "日本",
    Mongo: "蒙古",
    Pakis: "巴基斯坦",
    SoKore: "韩国",
    SriLan: "斯里兰卡",
    Taiw: "台湾",
    Afgh: "阿富汗",
    Azer: "阿塞拜疆",
    Kaza: "哈萨克斯坦",
    Camb: "柬埔寨",
    Indo: "印度尼西亚",
    Malay: "马来西亚",
    Phil: "菲律宾",
    Sing: "新加坡",
    Thai: "泰国",
    Viet: "越南",
    Bah: "巴林",
    Iran: "伊朗",
    Iraq: "伊拉克",
    Isra: "以色列",
    Jor: "约旦",
    Kuw: "科威特",
    Leb: "黎巴嫩",
    Oma: "也门",
    Qat: "卡塔尔",
    SauArb: "沙特阿拉伯",
    UAE: "阿拉伯联合酋长国",
    Alger: "阿尔及利亚",
    Angol: "安哥拉",
    Egyp: "埃及",
    Ghana: "加纳",
    Guin: "几内亚",
    Keny: "肯尼亚",
    Malaw: "马拉维",
    Moroc: "摩洛哥",
    Mozam: "莫桑比克",
    Nige: "尼日利亚",
    SoAfr: "南非",
    Tanz: "坦桑尼亚",
    Ugan: "乌干达",
    Zamb: "赞比亚",
    Austra: "澳大利亚",
    NewZea: "新西兰",
    //Culture Notes Dropdowns End
    culturenotes_mainintrotext: "熟悉对您的业务和职场生活至关重要的地区文化。",
    culturenotes_useculturalinfo: "利用我们的文化信息来准备与世界各地的客户和同事的重要会议。",
    culturenotes_topicfamiliarize: "熟悉其他文化的风俗习惯，例如工作时间、外出就餐、礼品馈赠等。",
    culturenotes_topiclearnculture: "了解文化习俗、文化差异以及风土人情，避免出现文化错误。",
    culturenotes_tmaworldtext: "国家报告由我们的合作伙伴TMA World开发制作、精心编制，采用 PDF 版本格式，方便下载。",
    culturenoteslocation_viewbytopic: "按主题查看",
    culturenoteslocation_viewbycountry: "按国家查看",
    culurecenter_disclaimer_title: "免责声明",
    culturecenter_disclaimer:
      "请把您将要阅读的信息当作一般性指南，目的是作为熟悉新文化的起点。该工具将帮助您了解常见的文化模式，并形成一个框架来更好地理解并解读人们行为、态度和反应中的文化差异。然而特别要记得，特定文化的共同特征也会因地区和个人性格而异。",
    culturecenter_intercept_title: "文化中心重新回归！​​",
    culturecenter_intercept_text1: "经过一段时间的梳理，我们很高兴地宣布：文化中心重新回归！",
    culturecenter_intercept_text2:
      "通过文化中心，您可以了解到世界上20个国家的专业做法和风俗习惯，包括美国、加拿大、墨西哥、中国、日本、印度等等。",
    culturecenter_intercept_direct: "前往文化中心​",
    dailyNewsFeed_resources: "资源",
    dailyNewsFeed_daily_News: "每日新闻速递",
    dailyNewsFeed_newsfeedoftheday: "每日新闻速递",
    dailyNewsFeed_feedcontent:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui. Phasellus interdum augue magna, in tempus velit imperdiet id.",
    dailyNewsFeed_noData: "对不起，我们无法获取新闻源，请稍后再试。",
    dailyNewsFeed_viewMoreCategories: "查看更多",
    // Email templates end
    //Error Page Translations
    error_not_found: "哎呀！没有找到页面。",
    error_contact_csm: "请联系我们的客户服务经理寻求帮助。",
    error_under: "在",
    error_maintenance: "维护",
    error_under_maintenance: "我们的网站目前正在进行定期维护。",
    error_inconvenience: "我们很抱歉给您带来任何不便。",
    error_tryagain: "请稍后再试",
    error_tryagainMins: "请在之后再试",
    error_minutes: "分钟",
    error_hours: "小时",
    error_oops: "哎呀！",
    error_permission_denied: "您没有权限查看该界面！",
    error_link_home: "主页",
    error_contact_admin: "请联系您的<donottrans> Learnship </donottrans> 管理员寻求帮助",
    error_sorry: "抱歉",
    error_load: "There was a problem loading this Page.",
    error_clear_cache: "请清除浏览器的缓存，检查网络连接，然后再次尝试。",
    error_contact: "请联系我们的",
    error_contact_cst: "客户服务团队",
    error_forhelp: "寻求帮助。",
    error_having_trouble: "还有困难？",
    //Accents and Dialects Dropdowns
    AF: "非洲",
    AS: "亚洲",
    AU: "澳大利亚 - 大洋洲",
    CA: "加勒比海",
    CE: "中美洲",
    EU: "欧洲",
    MI: "中东",
    NO: "北美地区",
    SO: "南美洲",
    CAMER: "喀麦隆",
    EGYPT: "埃及",
    ETHIO: "埃塞俄比亚",
    GHANA: "加纳",
    GUINE: "几内亚",
    NIGER: "尼日利亚",
    SOUTH: "南非",
    TANZA: "坦桑尼亚",
    AFGHA: "阿富汗",
    CHINA: "中国",
    INDIA: "印度",
    INDON: "印度尼西亚",
    JAPAN: "日本",
    KAZAK: "哈萨克斯坦",
    LEBAN: "黎巴嫩",
    MONGO: "蒙古",
    NORTH: "越南北部",
    PAKIS: "巴基斯坦",
    PHILI: "菲律宾",
    SINGA: "新加坡",
    KOREA: "韩国",
    SRI_L: "斯里兰卡",
    TAIWA: "台湾",
    THAIL: "泰国",
    TURKM: "土库曼斯坦",
    AUSTR: "澳大利亚",
    FIJI_: "斐济",
    NEW_Z: "新西兰",
    BERMU: "百慕达",
    CUBA_: "古巴",
    HAITI: "海地",
    COSTA: "哥斯达黎加",
    GUATE: "危地马拉",
    MARTI: "马提尼克（法属）",
    TRINI: "特立尼达和多巴哥",
    AUSTRI: "奥地利",
    BELAR: "白俄罗斯",
    BELGI: "比利时",
    BULGA: "保加利亚",
    CYPRU: "塞浦路斯",
    CZECH: "捷克",
    DENMA: "丹麦",
    ENGLA: "英格兰",
    FINLA: "芬兰",
    FRANC: "法国",
    GEORG: "格鲁吉亚",
    GERMA: "德国",
    GREEC: "希腊",
    HUNGA: "匈牙利",
    IRELA: "爱尔兰",
    ITALY: "意大利",
    MACED: "北馬其頓",
    NETHE: "荷兰",
    NORTHI: "北爱尔兰",
    POLAN: "波兰",
    ROMAN: "罗马尼亚",
    RUSSI: "俄罗斯联邦",
    SCOTL: "苏格兰",
    SPAIN: "西班牙",
    SWEDE: "瑞典",
    SWITZ: "瑞士",
    TURKE: "土耳其",
    UKRAI: "乌克兰",
    WALES: "威尔士",
    IRAN_: "伊朗",
    IRAQ_: "伊拉克",
    ISRAE: "以色列",
    KUWAI: "科威特",
    SAUDI: "沙特阿拉伯",
    SYRIA: "叙利亚共和国",
    CANAD: "加拿大",
    MEXIC: "墨西哥",
    ARGEN: "阿根廷",
    BRAZI: "巴西",
    CHILE: "智利",
    COLOM: "哥伦比亚",
    PARAG: "巴拉圭",
    PERU_: "秘鲁",
    VENEZ: "委内瑞拉",
    RPTitle: "彩虹段落",
    CGACTitle: "Comma Gets a Cure",
    accentsAndDialects_heading: "英语口音和方言",
    US: "美利坚合众国",
    ALABA: "阿拉巴马州",
    ALASK: "阿拉斯加州",
    ARKAN: "阿肯色州",
    CALIF: "加利福尼亚州",
    FLORI: "佛罗里达州",
    GEORG_US: "乔治亚州",
    HAWAI: "夏威夷州",
    ILLIN: "伊利诺斯州",
    INDIA_US: "印地安那州",
    KANSA: "堪萨斯州",
    KENTU: "肯塔基州",
    LOUIS: "路易斯安那州",
    MAINE: "缅因州",
    MARYL: "马里兰州",
    MASSA: "马萨诸塞州",
    MICHI: "密歇根州",
    MINNE: "明尼苏达州",
    MISSI: "密西西比州",
    MISSO: "密苏里州",
    MONTA: "蒙大拿州",
    NEBRA: "内布拉斯加州",
    NEW_H: "新罕布什尔州",
    NEW_J: "新泽西州",
    NEW_Y: "纽约州",
    NCARO: "北卡罗莱纳州",
    NDAKO: "北达科他州",
    OHIO_: "俄亥俄州",
    OKLAH: "俄克拉何马州",
    PENNS: "宾夕法尼亚州",
    SOUTH_US: "南卡罗莱纳州",
    TENNE: "田纳西州",
    TEXAS: "得克萨斯州",
    VIRGI: "弗吉尼亚州",
    WEST_: "西弗吉尼亚州",
    WISCO: "威斯康星州",
    //Accents and Dialects Dropdowns End
    manager_email_managertext:
      "贵公司要求为您的经理提供月度报告，说明您在Learnship的学习进展。请提供您经理的电子邮件地址。",
    // Survey and notification
    notification_description_plural: "剩余{days}天来完成调查。您必须在{date}之前完成。",
    notification_description_singular: "剩余1天来完成调查。您必须在{date}之前完成。",
    notification_maintenance_message: "Halo  将会在 {date} 日{time}时进行定期维护。",
    //renewal
    renewal_welcome: "欢迎回到 Learnship",
    renewal_text:
      "您的 Learnship 许可证将在 {year}年{month}月{date}日 到期。要继续提高您的商务英语交流能力，请在今天续订许可证。 您的学习计划和所有作业将被保存起来，您可以继续按当前的英语水平学习。",
    renewal_later: "请在以后询问我",
    renewal_affirmative: "我想续订许可证",
    renewal_negative: "我不想续订许可证",
    renewal_yes: "是",
    renewal_no: "否",
    courselevel: "课程级别",
    currentunit: "当前课程",
    upcomingsession: "即将进行课程",
    viewschedule: "View Schedule",
    currentskills: "技能",
    currentsubskills: "子技能",

    // TWT translations
    twt_talk_with_teacher_title: "跟老师谈话",
    twt_sub_heading: "通过在线课堂，和老师与其他同学一起练习对话吧！",
    twt_select_sessions: "选择课堂:",
    twt_view_schedule_title: "查看时间表添加到日历",
    twt_next_week: "下星期",
    twt_previous_week: "上星期",
    twt_add_to_calendar: "添加到日历中",
    twt_view_more: "查看更多",
    twt_topic: "话题",
    twt_class_policy_title: '"跟老师谈话"的政策和指南',
    twt_class_policy_subHeading:
      "以下的规定和说明对于确保您参加跟老师谈话的体验具有教育性和愉快性是很重要的. 请认真阅读.",
    twt_class_policy_list01:
      "您每星期可以参加1次跟老师谈话*. 课堂最多允许8位学员. 最佳方案: 在课堂开始前到达. 跟老师谈话课堂只允许在最初的10分钟内加入. 例如, 某节课 9:00 开始, 将只允许在 9:10前加入. 最初的10分钟后您将不能加入课堂.*有无限制取决于您的账户类型.",
    twt_class_policy_list02_sub1: "进入课堂时, 输入您的名字, 国家和级别.",
    twt_class_policy_list02_sub2: `例如, "My name is Leo, and I'm from Sao Paulo, Brazil. I'm in Level 6."`,
    twt_class_policy_list02_sub3: "然后讲师将激活您的麦克风，麦克风图标将出现。",
    twt_class_policy_list03:
      "如果您遇到技术问题, 请点击Learnship页面上部的帮助联系客户支持提交问题, 您也可以通过GlobalEnglish页面右下角的<b>Chat</b>工具联系客户服务人员. 请不要向老师寻求技术帮助.",
    twt_class_policy_list04:
      "跟老师谈话课堂有4个级别: 初级, 中级, 高级和所有级别. 您需要参加适合您级别的课堂. 例如, 如果您的级别是级别0-3, 您需要参加初级课堂. 任何学员 (任何级别) 可以参加所有级别课堂. 如果参加了错误级别的课堂, 老师会提示. 您有2个选择: 您可以告知老师您愿意留下不发言,也就是您不能参与 (说话); 或者您离开课堂参加其他时间适合的课堂.",
    twt_class_policy_list05:
      "如果您只想听一堂课, 不想发言, 每星期可以有1次这种机会. 每年只有4次. 如果您使用了这些机会还是想在课堂只听不参与发言, 您的课堂将会被终止.",
    twt_class_policy_list06:
      "我们不会容忍下流和攻击性的语言. 如果您违反了这个规定, 我们将立刻将您清除课堂. 同时我们会告知您的经理, 并有可能终止您的账户.",
    twt_class_policy_ok: "Ok",
    twt_max_multi_window_error_message: "您已经通过其他设备进入了这节课. 登出后才可以在当前设备上参加.",
    twt_max_capacity_error_message: "抱歉由于人数已满您不能参加这节课堂, 请参加其他的课堂.",
    twt_notification_message: "会话课程现在开始，您想加入吗？",
    twt_limit_message: "您本周已参加一堂课。",
    twt_session_unavailable: "没有可用的课程",
    twt_select_language: "选择语言",

    //Vocabulary center translations
    vocab_center_product_headline: "Vocabulary center",
    vocab_center_search_word: "Search and add word",
    vocab_center_add_wordlist: "Add Word List",
    vocab_center_edit_wordlist: "Edit Word List",
    vocab_center_delete_wordlist: "Delete Word List",
    vocab_center_options_text: "Options",
    vocab_center_add_word: "Add Word",
    vocab_center_add_text: "Add",
    vocab_center_delete_wordlist_warning_message: "All the words under the list will be deleted. Click Yes to delete.",
    vocab_center_yes_text: "Yes",
    vocab_center_new_wordlist: "New Word List",
    vocab_center_created_wordlist_success_message: "You have successfully created your new word list",
    vocab_center_updated_wordlist_success_message: "You have successfully updated your word list",
    vocab_center_okay_text: "Okay",
    vocab_center_new_word_text: "New Word",
    vocab_center_enter_word_text: "Enter a word",
    vocab_center_word_exists_in_wordlist_warning_message: "This word already exists in this Word List",
    vocab_center_save_text: "Save",
    vocab_center_new_word_message: "This word does not exist. Do you want to create your own definition for the word ?",
    vocab_center_pos_label: "Part of speech",
    vocab_center_select_wordlist_text: "Select a word list",
    vocab_center_word_label: "Word",
    vocab_center_update_wordlist: "Update word list",
    vocab_center_definition_label: "Definition",
    vocab_center_translation_label: "Translation",
    vocab_center_sentence_label: "Sentence",
    vocab_center_note_label: "Note",
    vocab_center_cancel_text: "Cancel",
    vocab_center_delete_word_text: "Delete Word",
    vocab_center_delete_word_warning_message: "Are you sure you want to delete this word from the Word List ?",
    vocab_center_note_updated_message: "Your notes updated successfully!!",
    vocab_center_close_text: "Close",
    vocab_center_no_definition_text: "No definition available",
    vocab_center_no_translation_text: "No translation available",
    vocab_center_no_sentence_text: "No sentence available",
    vocab_center_no_note_text: "No notes added",
    vocab_center_word_save_message: "You have successfully saved the word in your word List",
    vocab_center_word_exists_error_message: "Selected word already exists in the same wordlist",
    vocab_center_submit_text: "Submit",
    vocab_center_delete_text: "Delete",
    vocab_center_edit_text: "Edit",
    vocab_center_no_word_message: "Oops! There are no words in your wordlist. Add new words!",
    vocab_center_no_wordlist_message: "Oops! There are no wordslist in {wordListName}. Add new wordslist!",
    vocab_center_enter_wordlist_text: "Enter a word list",
    vocab_center_feature_text:
      "Without grammar, Very little can be conveyed. Without vocabulary, nothing can be conveyed. - David Wilkins",

    // Stress and inotation translations
    stress_intonation_product_headline: "StressAndIntonation",
    stress_intonation_product_description:
      "Make your English more natural and easier to understand by learning how to use correct stress, rhythm, and intonation when you speak.",

    // Sounds of English translations
    soe_product_headline: "Sounds of English",
    soe_product_description: "Improve your communication skills by learning how to pronounce English sounds correctly.",
    soe_product_vowels: "Vowels",
    soe_product_consonants: "Consonants",
    soe_product_language_selection:
      "Select your language in the drop-down list to find the sounds that may be difficult for speakers of your language. Then select My Sounds to find the sounds that you had trouble with in the Pronunciation Practice and Communication Practice activities.",

    // Writing center
    wc_feature_headline: "写作中心",
    wc_feature_description: "Level up your professional writing ability via our targeted resources.",
    wc_feature_guideGroup1: "常见写作问题",
    wc_feature_guideGroup2: "一般商业通讯",
    wc_feature_guideGroup3: "商业文件",
    wc_feature_guideTitle11: "文章内容含糊不清的原因",
    wc_feature_guideTitle12: "基本写作错误",
    wc_feature_guideTitle13: "动词问题",
    wc_feature_guideTitle21: "商业通讯中直截了当",
    wc_feature_guideTitle22: "营销用语",
    wc_feature_guideTitle23: "日常商业习惯用语",
    wc_feature_guideTitle31: "有效的电子邮件",
    wc_feature_guideTitle32: "演说：一般要点",
    wc_feature_guideTitle33: "演说：有效的开场白",

    // sso leaner intercept
    learners_intercept_title: "IMPORTANT NOTICE",
    learners_intercept_text1: "The way you log on to Learnship is changing! Citi has partnered with Learnship to enable Single Sign On access for all global learners. As of 9:00am CEST on November 18, 2022, you will be required to go to ", 
    learners_intercept_text2: "It is important to note that you will no longer be able to log-on via ",
    learners_intercept_text3: "Please take note of this change and bookmark the new page. ",
    learners_intercept_text4: "For support, please reach out to your local HR contact or "
  },
};
